// Date formatting in es-PR, anchored to Puerto Rico time so the calendar reads
// the same regardless of the visitor's timezone.
const TZ = 'America/Puerto_Rico'
const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
const strip = (s: string) => s.replace(/\.$/, '')

const fmt = (iso: string, opts: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('es-PR', { ...opts, timeZone: TZ }).format(new Date(iso))

/** "Vie" */
export const weekdayShort = (iso: string) => cap(strip(fmt(iso, { weekday: 'short' })))
/** "03" */
export const dayNumber = (iso: string) => fmt(iso, { day: '2-digit' })
/** "JUL" */
export const monthShort = (iso: string) => strip(fmt(iso, { month: 'short' })).toUpperCase()
/** "Viernes 3 de julio" */
export const longDate = (iso: string) =>
  `${cap(fmt(iso, { weekday: 'long' }))} ${fmt(iso, { day: 'numeric' })} de ${fmt(iso, { month: 'long' })}`
/** "Julio 2026" */
export const monthYear = (iso: string) => cap(fmt(iso, { month: 'long', year: 'numeric' }))

export const pad2 = (n: number) => String(n).padStart(2, '0')
